<template>
  <h1>{{ $t('workspaces.createWorkspace') }}</h1>
  <workspace-form :is-loading="isLoading" @submit="handleSubmit">
    <owners-table v-model:selected-owners="selectedOwners" />
  </workspace-form>
</template>

<script lang="ts" setup>
  import { WorkspaceFormFields } from '@/components/WorkspaceForm/WorkspaceForm.types';
  import { useNavigator } from '@/composables/useNavigator';
  import { useSaveWorkspace } from '@/composables/api/workspaces/useSaveWorkspace';
  import { IAdUserInternalFormat } from 'types';
  import { ref } from 'vue';
  import { WorkspaceDetailsTab } from '../WorkspaceDetails/WorkspaceDetails.types';

  const { isLoading, createWorkspace } = useSaveWorkspace();
  const { goToWorkspaceDetailsTab } = useNavigator();

  const selectedOwners = ref<IAdUserInternalFormat[]>([]);

  async function handleSubmit(formFields: WorkspaceFormFields): Promise<void> {
    const selectedOwnersOids = selectedOwners.value.map((owner) => owner.oid);
    const workspaceId = await createWorkspace(formFields, selectedOwnersOids);
    if (workspaceId) {
      goToWorkspaceDetailsTab(workspaceId, WorkspaceDetailsTab.SETTINGS);
    }
  }
</script>

<style scoped lang="scss">
  h1 {
    margin-bottom: 1.25rem;
  }
</style>
